import { studentBirthdayColumn } from 'Src/components/StudentBirthday/StudentBirthday';
import * as React from 'react';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import propz from 'propz';
import { Component } from 'react';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { TwoPanelEditor } from 'Src/components/TwoPanelEditor/TwoPanelEditor';
import { Loader } from 'Src/components/Loader/Loader';
import { DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE } from 'Src/consts/table';
import { getTwoPanelEditorFilters } from 'Src/helpers/twoPanelEditor/twoPanelEditor';
import { DATE_INTERVAL, LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { AppUser } from 'Src/views/App/App';
import {
  getAllSchoolTournamentTeamPlayers,
  getSchoolTournamentTeam,
  getSchoolTournamentTeamPlayersCount,
  SchoolTournamentTeamPlayersBatchData,
  updateSchoolTournamentTeamPlayersBatch
} from 'Src/helpers/service/admin/tournamentTeamPlayers';
import { SchoolForm } from 'Src/models/form';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getAllHouses } from 'Src/helpers/service/admin/houses';
import { getGender } from 'Src/helpers/accessor/accessor';
import {
  getSelectOptionForAge,
  getSelectOptionForForms,
  getSelectOptionForGender,
  getSelectOptionForHouses
} from 'Src/helpers/table/select';
import { getUserGenderArrayConvertedFromEventGender } from 'Src/helpers/tournament/tournament';
import { formatAgesCompactForSchool } from 'Src/helpers/ageGroups';
import { TournamentTeamPlayer } from '../../../../models/tournamentTeamPlayer';
import { Count } from '../../../../models/count';
import { getColorClashes } from '../../../../helpers/cell/cell';
import { AGE_GROUPS } from '../../../../consts/school';
import { getEventClash, getEventTitle, getStudentsMethod, isMultipartyEvent } from '../../../../helpers/event/event';
import {
  getSchoolStudentsWithClashesCount,
  getSchoolStudentsWithoutClashes
} from '../../../../helpers/service/admin/schoolTeamPlayers';
import { SchoolStudentClash } from '../../../../models/schoolStudent';
import { SchoolEventTeamPlayerWithClashes } from '../../../../models/eventTeamPlayer';
import { SchoolEvent } from '../../../../models/event';
import { getSchoolEvent } from '../../../../helpers/service/admin/event';
import { SimpleModal } from '../../../../components/SimpleModal/SimpleModal';
import { CLASHES } from '../../../../consts/player';
import { StudentForm } from 'Src/components/StudentForm/StudentForm';
import { addSchoolStudent, updateSchoolStudent } from 'Src/helpers/service/admin/students';
import {
  SchoolUnionSchoolStudentForm,
  SchoolUnionSchoolStudentFormHandle
} from 'Src/components/SchoolUnionSchoolStudentForm/SchoolUnionSchoolStudentForm';
import { addSchoolUnionSchoolStudent } from 'Src/helpers/service/adminSU/schoolStudentsTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { getAllSchoolTournamentTeams } from 'Src/helpers/service/admin/tournamentTeams';
import { Switch } from 'Src/components/Switch/Switch';
import './TournamentEvents.css';

interface TournamentTeamPlayersManagerApi {
  getTournament?: (user: AppUser, tournamentId: string) => Promise<any>;
  getTeam?: (user: AppUser, tournamentId: string, teamId: string) => Promise<any>;
  getForms?: (user: AppUser) => Promise<SchoolForm[]>;
  getHouses?: (user: AppUser) => Promise<any[]>;
  getTeams?: (user: AppUser, tournamentId: string) => Promise<any[]>;

  getAllTeamPlayers?: (user: AppUser, tournamentId: string, teamId: string, filter?: any) => Promise<any[]>;
  getTeamPlayers?: (user: AppUser, tournamentId: string, teamId: string, filter?: any) => Promise<any[]>;
  getTeamPlayersCount?: (user: AppUser, tournamentId: string, teamId: string, where?: any) => Promise<any>;

  updateTeamPlayersBatch?: (
    user: AppUser,
    tournamentId: string,
    teamId: string,
    data: SchoolTournamentTeamPlayersBatchData
  ) => Promise<any>;

  updatePlayerQuantumNumber?: (
    user: AppUser,
    tournamentId: string,
    teamId: string,
    playerId: string,
    data: { quantumPlayerNumber: number | null }
  ) => Promise<any>;

  assignPlayerNumbersToTeam?: (
    user: AppUser,
    tournamentId: string,
    teamId: string,
    data: { startFrom: number; endAt?: number }
  ) => Promise<any>;

  assignPlayerNumbersToTournament?: (user: AppUser, tournamentId: string, data: { startFrom: number }) => Promise<any>;

  getStudents?: (user: AppUser, filter: any) => Promise<any[]>;
  getStudentsCount?: (user: AppUser, where: any) => Promise<any>;
  getAllStudents?: (user: AppUser, where: any) => Promise<any[]>;
  addStudent?: (user: AppUser, data: any) => Promise<any>;
  updateStudent?: (user: AppUser, studentId: string, data: any) => Promise<any>;
}

interface TournamentPlayerTeamConflict {
  userId: string;
  playerName: string;
  selectedTeamId: string;
  teams: Array<{ teamId: string; teamName: string; playerId?: string; isCurrent: boolean }>;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;

  api?: TournamentTeamPlayersManagerApi;
  isPlayerNumbersEnabled?: boolean;
  isSchoolColumnEnabled?: boolean;
  isAgeGroupColumnEnabled?: boolean;
  isUnionTeamStudentFormEnabled?: boolean;
  isUnionSide?: boolean;
  unionTeamStudentFormUser?: AppUser;
  studentFormUser?: AppUser;
}

interface State {
  items: Item[];
  itemsSelected: Item[];
  itemsCount: number;

  itemsFilters: any;
  isShowItemsFilter: boolean;
  isItemsFiltered: boolean;

  isSelectAllItemsChecked: boolean;

  sortItemsDirection: TABLE_SORT_DIRECTION;
  sortItemsColumnsName: string;

  itemCurrentPage: number;

  itemsAccumulatorInitial: Item[];
  itemsAccumulator: Item[];
  itemsAccumulatorSelected: Item[];
  itemsAccumulatorCount: number;

  itemsAccumulatorFilters: any;
  isShowItemsAccumulatorFilter: boolean;
  isItemsAccumulatorFiltered: boolean;

  isSelectAllItemsAccumulatorChecked: boolean;

  sortItemsAccumulatorDirection: TABLE_SORT_DIRECTION;
  sortItemsAccumulatorColumnsName: string;

  tournament: any;
  team: any;
  forms: SchoolForm[];
  houses: any[];

  isLoading: boolean;

  itemsAddBuffer: Item[];
  itemsRemoveBuffer: Item[];

  studentEventsModalText: string;
  isStudentEventsModalOpen: boolean;

  isShowYounger: boolean;
  isExitConfirmationModalOpen: boolean;

  errorMessage: string;

  isAddStudentModalOpen: boolean;
  studentToAdd: Item | null;
  chosenSchoolId: string;
  chosenSchoolForms: SchoolForm[];

  isEditStudentModalOpen: boolean;
  studentToEdit: Item | null;

  isEditPlayerNumberModalOpen: boolean;
  editPlayerNumberValue: string;
  isSavingPlayerNumber: boolean;
  playerNumberError: string;
  isAssignTeamNumbersModalOpen: boolean;
  assignTeamNumbersStart: string;
  assignTeamNumbersEnd: string;
  assignTeamNumbersMode: 'FILL_MISSING' | 'RENUMBER_ALL';
  isSavingTeamNumbers: boolean;
  teamNumbersError: string;
  teamPlayerConflicts: TournamentPlayerTeamConflict[];
  isCheckingTeamPlayerConflicts: boolean;
  itemsHiddenFields: Set<string>;
  itemsAccumulatorHiddenFields: Set<string>;
  itemsSearch: string;
  isItemsLoading: boolean;
}

const ITEMS_ACCUMULATOR_COLUMNS: ColumnDefinition[] = [
  studentBirthdayColumn,
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['form', 'name']
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getGender
  }
];

const ITEMS_COLUMNS: ColumnDefinition[] = [
  studentBirthdayColumn,
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['form', 'name']
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  }
];

/*const ITEMS_COLUMNS_WITH_CLASHES: ColumnDefinition[] = [
  {
    text: 'Clashes',
    field: 'clashes',
    cell: getColorClashes,
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['form', 'name']
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  }
];
*/

interface Item {
  birthday?: string;
  permissionId: string;
  form: any;
  house?: any;
  gender: string;
  firstName: string;
  lastName: string;
  schoolId?: string;
  schoolName?: string;
  id: string;
  playerId?: string;
  quantumPlayerNumber?: number | null;
  clashes: {
    status?: string;
    fullClashEvents?: any[];
    intervalClashEvents?: any[];
  };
}

const DEFAULT_TEAM_PLAYERS_ORDER = 'firstName ASC';

export class TournamentTeamPlayersManager extends Component<Props, State> {
  private studentFormRef = React.createRef<SchoolUnionSchoolStudentFormHandle>();

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      itemsCount: 0,
      itemsSelected: [],

      itemsFilters: {},
      isShowItemsFilter: false,
      isItemsFiltered: false,

      isSelectAllItemsChecked: false,

      sortItemsDirection: '',
      sortItemsColumnsName: '',

      itemCurrentPage: 1,

      itemsAccumulatorInitial: [],
      itemsAccumulator: [],
      itemsAccumulatorCount: 0,
      itemsAccumulatorSelected: [],

      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,

      isSelectAllItemsAccumulatorChecked: false,

      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',

      tournament: undefined,
      team: undefined,
      forms: [],
      houses: [],

      isLoading: true,

      itemsAddBuffer: [],
      itemsRemoveBuffer: [],

      studentEventsModalText: '',
      isStudentEventsModalOpen: false,

      isShowYounger: false,
      isExitConfirmationModalOpen: false,

      errorMessage: '',

      isAddStudentModalOpen: false,
      studentToAdd: null,
      chosenSchoolId: '',
      chosenSchoolForms: [],

      isEditStudentModalOpen: false,
      studentToEdit: null,

      isEditPlayerNumberModalOpen: false,
      editPlayerNumberValue: '',
      isSavingPlayerNumber: false,
      playerNumberError: '',
      isAssignTeamNumbersModalOpen: false,
      assignTeamNumbersStart: '1',
      assignTeamNumbersEnd: '',
      assignTeamNumbersMode: 'FILL_MISSING',
      isSavingTeamNumbers: false,
      teamNumbersError: '',
      teamPlayerConflicts: [],
      isCheckingTeamPlayerConflicts: false,
      itemsHiddenFields: this.loadHiddenFields('tournamentTeamPlayers_items'),
      itemsAccumulatorHiddenFields: this.loadHiddenFields('tournamentTeamPlayers_accumulator'),
      itemsSearch: '',
      isItemsLoading: false
    };
  }

  private itemsSearchRequestId = 0;
  private static ALWAYS_VISIBLE_COLUMNS = new Set(['birthday', 'firstName', 'lastName', 'clashes']);

  private loadHiddenFields(key: string): Set<string> {
    try {
      const userId = this.props.user && this.props.user.userId ? this.props.user.userId : 'anonymous';
      const value = localStorage.getItem(`columnVisibility__${userId}__${key}`);
      return value ? new Set<string>(JSON.parse(value).filter(field => !TournamentTeamPlayersManager.ALWAYS_VISIBLE_COLUMNS.has(field))) : new Set();
    } catch {
      return new Set();
    }
  }

  private saveHiddenFields(key: string, fields: Set<string>): void {
    try {
      const userId = this.props.user && this.props.user.userId ? this.props.user.userId : 'anonymous';
      localStorage.setItem(`columnVisibility__${userId}__${key}`, JSON.stringify(Array.from(fields)));
    } catch {}
  }

  isColumnToggleable = (field: string): boolean => !TournamentTeamPlayersManager.ALWAYS_VISIBLE_COLUMNS.has(field);

  onToggleItemsColumn = (field: string): void => {
    if (!this.isColumnToggleable(field)) return;
    this.setState(prevState => {
      const fields = new Set(prevState.itemsHiddenFields);
      fields.has(field) ? fields.delete(field) : fields.add(field);
      this.saveHiddenFields('tournamentTeamPlayers_items', fields);
      return { itemsHiddenFields: fields };
    });
  };

  onToggleItemsAccumulatorColumn = (field: string): void => {
    if (!this.isColumnToggleable(field)) return;
    this.setState(prevState => {
      const fields = new Set(prevState.itemsAccumulatorHiddenFields);
      fields.has(field) ? fields.delete(field) : fields.add(field);
      this.saveHiddenFields('tournamentTeamPlayers_accumulator', fields);
      return { itemsAccumulatorHiddenFields: fields };
    });
  };

  getApi() {
    const { api } = this.props;

    return {
      getTournament: api?.getTournament || getTournament,
      getTeam: api?.getTeam || getSchoolTournamentTeam,
      getForms: api?.getForms || getAllForms,
      getHouses: api?.getHouses,
      getTeams: api?.getTeams || getAllSchoolTournamentTeams,

      getAllTeamPlayers: api?.getAllTeamPlayers || getAllSchoolTournamentTeamPlayers,
      getTeamPlayers: api?.getTeamPlayers || getAllSchoolTournamentTeamPlayers,
      getTeamPlayersCount: api?.getTeamPlayersCount || getSchoolTournamentTeamPlayersCount,
      updateTeamPlayersBatch: api?.updateTeamPlayersBatch || updateSchoolTournamentTeamPlayersBatch,

      updatePlayerQuantumNumber: api?.updatePlayerQuantumNumber,
      assignPlayerNumbersToTeam: api?.assignPlayerNumbersToTeam,
      assignPlayerNumbersToTournament: api?.assignPlayerNumbersToTournament,

      getStudents: api?.getStudents,
      getStudentsCount: api?.getStudentsCount,
      getAllStudents: api?.getAllStudents,
      addStudent: api?.addStudent
    };
  }

  getEligibleStudents(user: AppUser, filter: any) {
    const { getStudents } = this.getApi();
    return getStudents ? getStudents(user, filter) : getStudentsMethod(user)(user, filter);
  }

  getEligibleStudentsCount(user: AppUser, filter: any) {
    const { getStudentsCount } = this.getApi();
    const countPromise = getStudentsCount
      ? getStudentsCount(user, filter.where)
      : getSchoolStudentsWithClashesCount(user, filter);

    return countPromise.then(result => ({
      count: Number(propz.get(result, ['count', 'count'], propz.get(result, ['count'], 0)))
    }));
  }

  getEligibleStudentsCountFromPage(students: any[], filter: any, count: Count): Count {
    if (count.count > 0) {
      return count;
    }

    const skip = filter.skip || 0;
    const limit = filter.limit || students.length;
    const hasNextPage = students.length === limit;
    return { count: skip + students.length + (hasNextPage ? 1 : 0) };
  }

  getAllEligibleStudents(user: AppUser, filter: any) {
    const { getAllStudents } = this.getApi();
    return getAllStudents ? getAllStudents(user, filter.where) : getSchoolStudentsWithoutClashes(user, filter);
  }

  searchLoadedItems = (items: any[], text: string): Promise<any[]> => {
    const searchText = (text || '').trim().toLowerCase();

    if (searchText === '') {
      return BPromise.resolve(items);
    }

    return BPromise.resolve(
      items.filter(item => {
        const name = String(propz.get(item, ['name'], '') || propz.get(item, ['ageGroup'], '')).toLowerCase();
        return name.includes(searchText);
      })
    );
  };

  isUnionTeamStudentFormMode(team = this.state.team): boolean {
    const search = parse(this.props.history.location.search);
    const contextSchoolKind = search.contextSchoolKind as string;
    const teamSchoolKind = String(propz.get(team, ['school', 'kind'], propz.get(team, ['schoolKind'], '')) || '');
    const teamSchoolIds = propz.get(team, ['school', 'schoolIds']);

    return (
      this.props.isUnionTeamStudentFormEnabled ||
      contextSchoolKind === 'SchoolUnion' ||
      teamSchoolKind === 'SchoolUnion' ||
      Array.isArray(teamSchoolIds)
    );
  }

  getContextSchoolId(team = this.state.team): string {
    const search = parse(this.props.history.location.search);
    return String(search.contextSchoolId || propz.get(team, ['schoolId'], propz.get(team, ['school', 'id'], '')) || '');
  }

  getTournamentId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const tournamentId = search.tournamentId;
    return tournamentId;
  }

  getTeamId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const teamId = search.teamId;
    return teamId;
  }

  getActionsColumn = (onEditClick?: (item: Item) => void): ColumnDefinition => ({
    text: '',
    field: 'actions',
    type: FILTER_TYPE.NONE,
    isSort: false,
    cell: (item: Item) => {
      return onEditClick ? (
        <button
          type="button"
          onClick={e => {
            e.stopPropagation();
            onEditClick(item);
          }}
          className="ttm-edit-btn"
          aria-label={`Edit ${item.firstName} ${item.lastName}`}
          title={`Edit ${item.firstName} ${item.lastName}`}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ) : null;
    }
  });

  getItemsColumns = (): ColumnDefinition[] => {
    const columns: ColumnDefinition[] = [
      studentBirthdayColumn,
      {
        text: 'Surname',
        field: 'lastName',
        accessor: ['lastName'],
        type: FILTER_TYPE.TEXT,
        isSort: false
      },
      {
        text: 'Name',
        field: 'firstName',
        accessor: ['firstName'],
        type: FILTER_TYPE.TEXT,
        isSort: false
      },
      {
        text: this.props.isAgeGroupColumnEnabled ? 'Year group' : 'Form',
        field: 'forms',
        isSort: false,
        type: FILTER_TYPE.MULTISELECT,
        accessor: ['form', this.props.isAgeGroupColumnEnabled ? 'ageGroup' : 'name']
      },
      {
        text: 'Gender',
        field: 'gender',
        isSort: false,
        type: FILTER_TYPE.MULTISELECT,
        accessor: getGender
      }
    ];

    if (this.props.isSchoolColumnEnabled) {
      columns.splice(2, 0, {
        text: 'School',
        field: 'schoolName',
        accessor: ['schoolName'],
        type: FILTER_TYPE.NONE,
        isSort: false
      });
    }

    columns.push(this.getActionsColumn(this.handleEditClick));
    return columns;
  };

  getItemsAccumulatorColumns = (): ColumnDefinition[] => {
    const { isPlayerNumbersEnabled } = this.props;

    const columns: ColumnDefinition[] = [
      studentBirthdayColumn,
      {
        text: 'Surname',
        field: 'lastName',
        accessor: ['lastName'],
        type: FILTER_TYPE.NONE,
        isSort: false
      },
      {
        text: 'Name',
        field: 'firstName',
        accessor: ['firstName'],
        type: FILTER_TYPE.NONE,
        isSort: false
      }
    ];

    if (this.props.isSchoolColumnEnabled) {
      columns.push({
        text: 'School',
        field: 'schoolName',
        accessor: ['schoolName'],
        type: FILTER_TYPE.NONE,
        isSort: false
      });
    }

    if (isPlayerNumbersEnabled) {
      columns.push({
        text: 'Athlete No.',
        field: 'quantumPlayerNumber',
        accessor: ['quantumPlayerNumber'],
        type: FILTER_TYPE.NONE,
        isSort: false
      });
    }

    columns.push(
      {
        text: this.props.isAgeGroupColumnEnabled ? 'Year group' : 'Form',
        field: 'forms',
        isSort: false,
        type: FILTER_TYPE.NONE,
        accessor: ['form', this.props.isAgeGroupColumnEnabled ? 'ageGroup' : 'name']
      },
      {
        text: 'Gender',
        field: 'gender',
        isSort: false,
        type: FILTER_TYPE.NONE,
        accessor: getGender
      }
    );

    return columns;
  };

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const itemsFilters = getTwoPanelEditorFilters(ITEMS_COLUMNS);
    const isShowItemsFilter = isFilterExist2(itemsFilters);
    const isItemsFiltered = isFilterExist2(itemsFilters);

    const itemsAccumulatorFilters = getTwoPanelEditorFilters(ITEMS_ACCUMULATOR_COLUMNS);
    const isShowItemsAccumulatorFilter = isFilterExist2(itemsAccumulatorFilters);
    const isItemsAccumulatorFiltered = isFilterExist2(itemsAccumulatorFilters);

    const api = this.getApi();

    const studentFormUser = this.props.studentFormUser || user;

    BPromise.all([api.getTournament(user, tournamentId), api.getTeam(user, tournamentId, teamId), api.getForms(user)])
      .then(([_tournament, _team, _forms]) => {
        const housesPromise = this.isUnionTeamStudentFormMode(_team)
          ? BPromise.resolve([])
          : api.getHouses
          ? api.getHouses(user)
          : getAllHouses(studentFormUser);

        return housesPromise.then(_houses => ({ _tournament, _team, _forms, _houses }));
      })
      .then(({ _tournament, _team, _forms, _houses }) => {
        const defaultItemsFilter = this.getDefaultItemsFilter(_team, _forms);

        window.dispatchEvent(
          new CustomEvent('sit:topbar-breadcrumb', {
            detail: `${_tournament.name} / Manage teams / ${_team.name} / Manage participants`
          })
        );

        return new BPromise<void>(resolve => {
          this.setState(
            {
              tournament: _tournament,
              team: _team,
              forms: _forms,
              houses: _houses,
              itemsFilters: defaultItemsFilter
            },
            () => resolve()
          );
        }).then(() => this.getItemsAndItemsAccumulator());
      })
      .then(({ teamPlayersInitial, teamPlayers, teamPlayersCount, students, studentsCount }) => {
        const studentsNormalized = this.getStudentsNormalized((students as unknown) as SchoolStudentClash[]);
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        this.setState({
          items: studentsNormalized,
          itemsCount: ((studentsCount as unknown) as Count).count,
          isShowItemsFilter: isShowItemsFilter,
          isItemsFiltered: true,

          itemsAccumulatorInitial: teamPlayersInitialNormalized,
          itemsAccumulator: teamPlayersNormalized,
          itemsAccumulatorCount: teamPlayersCount.count,
          itemsAccumulatorFilters: itemsAccumulatorFilters,
          isShowItemsAccumulatorFilter: isShowItemsAccumulatorFilter,
          isItemsAccumulatorFiltered: isItemsAccumulatorFiltered,

          isLoading: false
        });
      });
  }

  componentWillUnmount() {
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  getTeamPlayersNormalized(teamPlayers: TournamentTeamPlayer[]): Item[] {
    return teamPlayers.map(teamPlayer => {
      const {
        permissionId,
        form,
        house,
        gender,
        birthday,
        firstName,
        lastName,
        userId,
        id,
        quantumPlayerNumber,
        schoolId,
        schoolName
      } = teamPlayer as any;
      const playerMeta = [
        this.getStudentYearGroup(form),
        typeof quantumPlayerNumber === 'number' ? `Tournament no. ${quantumPlayerNumber}` : ''
      ]
        .filter(Boolean)
        .join(' · ');
      return {
        permissionId,
        form,
        house,
        gender,
        birthday,
        firstName,
        lastName,
        schoolId,
        schoolName,
        id: userId,
        playerId: id,
        quantumPlayerNumber: typeof quantumPlayerNumber === 'number' ? quantumPlayerNumber : null,
        transferMeta: playerMeta,
        eligibilityWarning: this.getTeamAgeWarning(form),
        clashes: {
          status: CLASHES.NO_CLASH,
          fullClashEvents: [],
          intervalClashEvents: []
        }
      };
    });
  }

  getStudentsNormalized(students: SchoolStudentClash[]): Item[] {
    return students.map(student => {
      const {
        id,
        permissionId,
        form,
        house,
        gender,
        birthday,
        firstName,
        lastName,
        schoolId,
        schoolName,
        clashes
      } = student as any;
      return {
        id,
        permissionId,
        form,
        house,
        gender,
        birthday,
        firstName,
        lastName,
        schoolId,
        schoolName,
        transferMeta: this.getStudentYearGroup(form),
        eligibilityWarning: this.getTeamAgeWarning(form),
        clashes: clashes || {
          status: 'NO_CLASH',
          fullClashEvents: [],
          intervalClashEvents: []
        }
      };
    });
  }

  getTeamAgeWarning(form: any): string {
    const teamAges = (this.state.team?.ages || []).map(Number).filter(Number.isFinite);
    const studentAge = Number(propz.get(form, ['age']));
    if (!Number.isFinite(studentAge) || teamAges.includes(studentAge)) return '';
    return `Team: ${formatAgesCompactForSchool(
      teamAges,
      this.props.user.activeSchool
    )} · Student: ${formatAgesCompactForSchool([studentAge], this.props.user.activeSchool)}`;
  }

  getStudentYearGroup(form: any): string {
    if (!this.props.isAgeGroupColumnEnabled) return propz.get(form, ['name'], '') || '';
    const explicitAgeGroup = propz.get(form, ['ageGroup'], '');
    if (explicitAgeGroup) return explicitAgeGroup;
    const age = Number(propz.get(form, ['age']));
    return Number.isFinite(age) ? formatAgesCompactForSchool([age], this.props.user.activeSchool) : '';
  }

  getDefaultItemsFilter(team, forms, isStrictEqual = true) {
    const { gender, ages = [] } = team;
    const genderArrayConverted = getUserGenderArrayConvertedFromEventGender(gender);

    const tournamentAges = Array.from(
      new Set<number>(ages.map(Number).filter(age => Number.isFinite(age) && age >= 0))
    );
    const maxTournamentAge = tournamentAges.length > 0 ? Math.max(...tournamentAges) : -1;
    const schoolAges = Array.from(
      new Set<number>(
        forms.map(form => Number(form.age)).filter(age => Number.isFinite(age) && age >= 0 && age <= maxTournamentAge)
      )
    );
    const eligibleAges = isStrictEqual ? tournamentAges : schoolAges;

    return {
      firstName: '',
      lastName: '',
      gender: genderArrayConverted,
      ages: this.props.isAgeGroupColumnEnabled ? [] : eligibleAges.map(String),
      forms: this.props.isAgeGroupColumnEnabled ? eligibleAges.map(String) : []
    };
  }

  getItemsAndItemsAccumulator() {
    const { user } = this.props;
    const { itemsAccumulatorFilters } = this.state;
    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);
    const isAccumulatorFiltered = Object.keys(where).length > 0;

    const api = this.getApi();

    const getTeamPlayersInitialPromise = api.getAllTeamPlayers(user, tournamentId, teamId);
    const getTeamPlayersPromise = isAccumulatorFiltered
      ? api.getAllTeamPlayers(user, tournamentId, teamId, where)
      : getTeamPlayersInitialPromise;
    const getTeamPlayersCountPromise = isAccumulatorFiltered
      ? api.getTeamPlayersCount(user, tournamentId, teamId, where)
      : getTeamPlayersInitialPromise.then(players => ({ count: players.length }));

    let teamPlayersInitial: TournamentTeamPlayer[], teamPlayers: TournamentTeamPlayer[], teamPlayersCount: Count;

    return BPromise.all([getTeamPlayersInitialPromise, getTeamPlayersPromise, getTeamPlayersCountPromise])
      .then(([_teamPlayersInitial, _teamPlayers, _teamPlayersCount]) => {
        teamPlayersInitial = _teamPlayersInitial;
        teamPlayers = _teamPlayers;
        teamPlayersCount = _teamPlayersCount;

        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        const filter = this.getItemsFilter(1, teamPlayersInitialNormalized, []);

        return BPromise.all([
          this.getEligibleStudents(user, filter),
          this.getEligibleStudentsCount(user, filter)
        ]).then(([students, studentsCount]) => [
          students,
          this.getEligibleStudentsCountFromPage(students, filter, studentsCount)
        ]);
      })
      .then(([students, studentsCount]) => {
        return {
          teamPlayersInitial,
          teamPlayers,
          teamPlayersCount,
          students,
          studentsCount
        };
      });
  }

  onItemClick = (index: number): void => {
    const { items, itemsSelected } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = itemsSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: [],
      itemsSelected: selectedItemsUpdated
    });
  };

  onItemAccumulatorClick = (index: number): void => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const selectedItem = itemsAccumulator[index];

    const selectedItemIndex = itemsAccumulatorSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsAccumulatorSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: selectedItemsUpdated,
      itemsSelected: []
    });
  };

  onAddClick = () => {
    const { itemsSelected, itemsAddBuffer, itemsAccumulator, itemCurrentPage } = this.state;
    const { user } = this.props;

    const existingAccumulatorIds = new Set((itemsAccumulator || []).map(item => String(item.id)));
    const existingAddBufferIds = new Set((itemsAddBuffer || []).map(item => String(item.id)));

    const selectedToAdd = (itemsSelected || []).filter(
      item => !existingAccumulatorIds.has(String(item.id)) && !existingAddBufferIds.has(String(item.id))
    );

    const nextItemsAddBuffer = [...(itemsAddBuffer || []), ...selectedToAdd];
    const nextItemsAccumulator = [...(itemsAccumulator || []), ...selectedToAdd];

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulator, nextItemsAddBuffer);
    const getStudentsPromise = this.getEligibleStudents(user, filter);
    const getStudentsCountPromise = this.getEligibleStudentsCount(user, filter);

    BPromise.all([getStudentsPromise, getStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized((students as unknown) as SchoolStudentClash[]);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: ((studentsCount as unknown) as Count).count,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false
      });
    });
  };

  onRemoveClick = () => {
    const {
      itemsAccumulatorSelected,
      itemsAddBuffer,
      itemsRemoveBuffer,
      itemsAccumulatorInitial,
      itemsAccumulator,
      itemCurrentPage
    } = this.state;
    const { user } = this.props;

    const selectedIds = new Set((itemsAccumulatorSelected || []).map(x => String(x.id)));
    const addBufferIds = new Set((itemsAddBuffer || []).map(x => String(x.id)));

    const selectedExistingParticipants = (itemsAccumulatorSelected || []).filter(x => !addBufferIds.has(String(x.id)));

    const nextItemsAddBuffer = (itemsAddBuffer || []).filter(x => !selectedIds.has(String(x.id)));

    const existingRemoveIds = new Set((itemsRemoveBuffer || []).map(x => String(x.id)));
    const nextItemsRemoveBuffer = [
      ...(itemsRemoveBuffer || []),
      ...selectedExistingParticipants.filter(x => !existingRemoveIds.has(String(x.id)))
    ];

    const nextItemsAccumulatorInitial = (itemsAccumulatorInitial || []).filter(
      itemAccumulatorInitial =>
        !nextItemsRemoveBuffer.some(
          nextItemRemoveBuffer => String(nextItemRemoveBuffer.id) === String(itemAccumulatorInitial.id)
        )
    );

    const nextItemsAccumulator = (itemsAccumulator || []).filter(
      itemAccumulator => !selectedIds.has(String(itemAccumulator.id))
    );

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulatorInitial, nextItemsAddBuffer);
    const getStudentsPromise = this.getEligibleStudents(user, filter);
    const getStudentsCountPromise = this.getEligibleStudentsCount(user, filter);

    BPromise.all([getStudentsPromise, getStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsRemoveBuffer: nextItemsRemoveBuffer,
        itemsAccumulatorInitial: nextItemsAccumulatorInitial,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length
      });
    });
  };

  removeItemFromBuffer = (itemId: string) => {
    this.setState(prevState => {
      const removedItem = prevState.itemsAddBuffer.find(item => item.id === itemId);
      const updatedItemsAddBuffer = prevState.itemsAddBuffer.filter(item => item.id !== itemId);
      const updatedItems = removedItem ? [...prevState.items, removedItem] : prevState.items;

      return {
        itemsAddBuffer: updatedItemsAddBuffer,
        items: updatedItems
      };
    });
  };

  getTeamPlayerConflicts = (): Promise<TournamentPlayerTeamConflict[]> => {
    const { itemsAddBuffer, itemsRemoveBuffer, itemsAccumulatorInitial } = this.state;
    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const currentTeamId = String(this.getTeamId());
    const removedIds = new Set(itemsRemoveBuffer.map(item => String(item.id)));
    const finalItems = [...itemsAccumulatorInitial.filter(item => !removedIds.has(String(item.id))), ...itemsAddBuffer];
    const finalItemsById = new Map(finalItems.map(item => [String(item.id), item]));
    const initialIds = new Set(itemsAccumulatorInitial.map(item => String(item.id)));
    const currentTeamName = propz.get(this.state, ['team', 'name'], 'Current team');
    const currentPlayersById = new Map(itemsAccumulatorInitial.map(item => [String(item.id), item]));
    const api = this.getApi();

    if (finalItemsById.size === 0) return Promise.resolve([]);

    return api.getTeams(user, tournamentId).then(teams => {
      const otherTeams = (teams || []).filter(team => String(team.id) !== currentTeamId);

      return Promise.all(
        otherTeams.map(team =>
          api.getAllTeamPlayers(user, tournamentId, team.id).then(players => ({ team, players: players || [] }))
        )
      ).then(teamPlayers => {
        const conflictsByUserId = new Map<string, TournamentPlayerTeamConflict>();

        teamPlayers.forEach(({ team, players }) => {
          players.forEach(player => {
            const userId = String(player.userId);
            const currentItem = finalItemsById.get(userId);
            if (!currentItem) return;

            let conflict = conflictsByUserId.get(userId);
            if (!conflict) {
              const playerName =
                `${currentItem.firstName || player.firstName || ''} ${currentItem.lastName ||
                  player.lastName ||
                  ''}`.trim() || 'Student';
              const currentPlayer = currentPlayersById.get(userId);
              conflict = {
                userId,
                playerName,
                selectedTeamId: initialIds.has(userId) ? currentTeamId : String(team.id),
                teams: [
                  {
                    teamId: currentTeamId,
                    teamName: currentTeamName,
                    playerId: currentPlayer && currentPlayer.playerId,
                    isCurrent: true
                  }
                ]
              };
              conflictsByUserId.set(userId, conflict);
            }

            conflict.teams.push({
              teamId: String(team.id),
              teamName: team.name || 'Tournament team',
              playerId: player.id,
              isCurrent: false
            });
          });
        });

        return Array.from(conflictsByUserId.values());
      });
    });
  };

  saveTeamChanges = (conflicts: TournamentPlayerTeamConflict[] = []) => {
    const { itemsAddBuffer, itemsRemoveBuffer, itemsAccumulatorInitial } = this.state;
    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const currentTeamId = String(this.getTeamId());
    const selectedTeamByUserId = new Map(conflicts.map(conflict => [conflict.userId, conflict.selectedTeamId]));
    const initialPlayerByUserId = new Map(itemsAccumulatorInitial.map(item => [String(item.id), item.playerId]));

    const currentAdd = itemsAddBuffer.filter(item =>
      selectedTeamByUserId.has(String(item.id)) ? selectedTeamByUserId.get(String(item.id)) === currentTeamId : true
    );
    const currentRemoveIds = new Set<string>(
      itemsRemoveBuffer.map(item => item.playerId).filter((playerId): playerId is string => Boolean(playerId))
    );
    const removalsByTeamId = new Map<string, Set<string>>();

    conflicts.forEach(conflict => {
      if (conflict.selectedTeamId !== currentTeamId) {
        const currentPlayerId = initialPlayerByUserId.get(conflict.userId);
        if (currentPlayerId) currentRemoveIds.add(currentPlayerId);
      }

      conflict.teams.forEach(team => {
        if (team.isCurrent || team.teamId === conflict.selectedTeamId || !team.playerId) return;
        const removals = removalsByTeamId.get(team.teamId) || new Set<string>();
        removals.add(team.playerId);
        removalsByTeamId.set(team.teamId, removals);
      });
    });

    const currentData: SchoolTournamentTeamPlayersBatchData = {
      add: currentAdd.map(item => ({ userId: item.id, permissionId: item.permissionId })),
      remove: Array.from(currentRemoveIds)
    };
    const updates: Array<Promise<any>> = [
      this.getApi().updateTeamPlayersBatch(user, tournamentId, currentTeamId, currentData)
    ];

    removalsByTeamId.forEach((playerIds, teamId) => {
      updates.push(this.getApi().updateTeamPlayersBatch(user, tournamentId, teamId, { remove: Array.from(playerIds) }));
    });

    this.setState({
      errorMessage: '',
      isLoading: true,
      isCheckingTeamPlayerConflicts: false,
      teamPlayerConflicts: [],
      itemsSelected: [],
      itemsAddBuffer: [],
      itemsRemoveBuffer: []
    });

    Promise.all(updates)
      .then(() => this.getItemsAndItemsAccumulator())
      .then(({ teamPlayersInitial, teamPlayers, teamPlayersCount, students, studentsCount }) => {
        const studentsNormalized = this.getStudentsNormalized(students as SchoolStudentClash[]);
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        this.setState({
          items: studentsNormalized,
          itemsCount: (studentsCount as Count).count,
          itemsAccumulator: teamPlayersNormalized,
          itemsAccumulatorInitial: teamPlayersInitialNormalized,
          itemsAccumulatorCount: teamPlayersCount.count,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          errorMessage: this.getErrorText(error),
          isLoading: false
        });
        console.error('Save error:', error);
      });
  };

  onClickSave = () => {
    const { itemsAddBuffer, itemsRemoveBuffer, itemsAccumulatorInitial, tournament } = this.state;

    const currentTeamSet = new Set(itemsAccumulatorInitial.map(item => item.id));

    itemsRemoveBuffer.forEach(item => currentTeamSet.delete(item.id));

    itemsAddBuffer.forEach(item => currentTeamSet.add(item.id));

    const finalTeamSize = currentTeamSet.size;

    if (tournament.maxPlayersPerTeam && finalTeamSize > tournament.maxPlayersPerTeam) {
      this.setState({
        errorMessage: `Cannot save changes: The total number of team members exceeds the maximum allowed (${tournament.maxPlayersPerTeam}).`
      });
      return;
    }

    this.setState({ errorMessage: '', isCheckingTeamPlayerConflicts: true });

    this.getTeamPlayerConflicts()
      .then(conflicts => {
        if (conflicts.length > 0) {
          this.setState({ teamPlayerConflicts: conflicts, isCheckingTeamPlayerConflicts: false });
          return;
        }
        this.saveTeamChanges();
      })
      .catch(error => {
        this.setState({
          errorMessage: 'The other tournament teams could not be checked. Please try again.',
          isCheckingTeamPlayerConflicts: false
        });
        console.error('Team player conflict check error:', error);
      });
  };

  setTeamPlayerConflictChoice = (userId: string, selectedTeamId: string) => {
    this.setState(prevState => ({
      teamPlayerConflicts: prevState.teamPlayerConflicts.map(conflict =>
        conflict.userId === userId ? { ...conflict, selectedTeamId } : conflict
      )
    }));
  };

  closeTeamPlayerConflicts = () => this.setState({ teamPlayerConflicts: [] });

  confirmTeamPlayerConflicts = () => this.saveTeamChanges(this.state.teamPlayerConflicts);

  handleEditClick = (student: Item) => {
    this.setState({
      isEditStudentModalOpen: true,
      studentToEdit: student
    });
  };

  reloadItemsAndItemsAccumulator = () => {
    return this.getItemsAndItemsAccumulator().then(
      ({ teamPlayersInitial, teamPlayers, teamPlayersCount, students, studentsCount }) => {
        const studentsNormalized = this.getStudentsNormalized((students as unknown) as SchoolStudentClash[]);
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        this.setState({
          items: studentsNormalized,
          itemsCount: ((studentsCount as unknown) as Count).count,
          itemsAccumulator: teamPlayersNormalized,
          itemsAccumulatorInitial: teamPlayersInitialNormalized,
          itemsAccumulatorCount: teamPlayersCount.count
        });
      }
    );
  };

  getErrorText = (error: any): string => {
    return (
      propz.get(error, ['response', 'data', 'details', 'text']) ||
      propz.get(error, ['response', 'data', 'message']) ||
      propz.get(error, ['message']) ||
      'Something went wrong. Please try again.'
    );
  };

  hasUnsavedTeamChanges = (): boolean => {
    const { itemsAddBuffer, itemsRemoveBuffer } = this.state;

    return itemsAddBuffer.length > 0 || itemsRemoveBuffer.length > 0;
  };

  openEditPlayerNumberModal = () => {
    const { itemsAccumulatorSelected } = this.state;

    if (this.hasUnsavedTeamChanges()) {
      this.setState({
        errorMessage: 'Please save team changes before editing athlete numbers.'
      });
      return;
    }

    if (itemsAccumulatorSelected.length !== 1) {
      this.setState({
        errorMessage: 'Please select one team member first.'
      });
      return;
    }

    if (!itemsAccumulatorSelected[0].playerId) {
      this.setState({
        errorMessage: 'Please save this team member before editing athlete number.'
      });
      return;
    }

    this.setState({
      isEditPlayerNumberModalOpen: true,
      editPlayerNumberValue:
        typeof itemsAccumulatorSelected[0].quantumPlayerNumber === 'number'
          ? String(itemsAccumulatorSelected[0].quantumPlayerNumber)
          : '',
      playerNumberError: '',
      errorMessage: ''
    });
  };

  closeEditPlayerNumberModal = () => {
    this.setState({
      isEditPlayerNumberModalOpen: false,
      playerNumberError: '',
      errorMessage: ''
    });
  };

  openAssignTeamNumbersModal = () => {
    if (this.hasUnsavedTeamChanges()) {
      this.setState({
        errorMessage: 'Please save team changes before assigning athlete numbers.'
      });
      return;
    }

    this.setState({
      isAssignTeamNumbersModalOpen: true,
      assignTeamNumbersStart: '1',
      assignTeamNumbersEnd: '',
      assignTeamNumbersMode: 'FILL_MISSING',
      teamNumbersError: '',
      errorMessage: ''
    });
  };

  closeAssignTeamNumbersModal = () => {
    this.setState({
      isAssignTeamNumbersModalOpen: false,
      teamNumbersError: '',
      errorMessage: ''
    });
  };

  onSubmitEditPlayerNumber = (event: React.FormEvent) => {
    event.preventDefault();
    const { user } = this.props;
    const { itemsAccumulatorSelected } = this.state;
    const api = this.getApi();

    if (!api.updatePlayerQuantumNumber) {
      this.setState({ playerNumberError: 'Athlete numbers are not available in this context.' });
      return;
    }

    const selectedPlayer = itemsAccumulatorSelected[0];

    if (!selectedPlayer || !selectedPlayer.playerId) {
      this.setState({ playerNumberError: 'Select one saved team member first.' });
      return;
    }

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const rawValue = this.state.editPlayerNumberValue.trim();
    const quantumPlayerNumber = rawValue === '' ? null : Number(rawValue);
    if (quantumPlayerNumber !== null && (!Number.isInteger(quantumPlayerNumber) || quantumPlayerNumber < 1)) {
      this.setState({ playerNumberError: 'Enter a whole number of 1 or greater, or leave it empty to clear.' });
      return;
    }

    this.setState({ isSavingPlayerNumber: true, playerNumberError: '' });

    api
      .updatePlayerQuantumNumber(user, tournamentId, teamId, selectedPlayer.playerId, {
        quantumPlayerNumber
      })
      .then(() => this.reloadItemsAndItemsAccumulator())
      .then(() => {
        this.setState({
          isSavingPlayerNumber: false,
          isEditPlayerNumberModalOpen: false,
          itemsAccumulatorSelected: [],
          isSelectAllItemsAccumulatorChecked: false
        });
      })
      .catch(error => {
        this.setState({
          isSavingPlayerNumber: false,
          playerNumberError: this.getErrorText(error)
        });
      });
  };

  onSubmitAssignTeamNumbers = (event: React.FormEvent) => {
    event.preventDefault();
    const { user } = this.props;
    const api = this.getApi();

    if (!api.assignPlayerNumbersToTeam) {
      this.setState({ teamNumbersError: 'Athlete numbers are not available in this context.' });
      return;
    }

    const startFrom = Number(this.state.assignTeamNumbersStart);
    const endAt = this.state.assignTeamNumbersEnd.trim() === '' ? undefined : Number(this.state.assignTeamNumbersEnd);
    if (!Number.isInteger(startFrom) || startFrom < 1) {
      this.setState({ teamNumbersError: 'Enter a starting number of 1 or greater.' });
      return;
    }
    if (endAt !== undefined && (!Number.isInteger(endAt) || endAt < startFrom)) {
      this.setState({ teamNumbersError: 'The final number must be equal to or greater than the starting number.' });
      return;
    }

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    this.setState({
      isSavingTeamNumbers: true,
      teamNumbersError: ''
    });

    api
      .assignPlayerNumbersToTeam(user, tournamentId, teamId, {
        startFrom,
        endAt,
        mode: this.state.assignTeamNumbersMode
      })
      .then(() => this.reloadItemsAndItemsAccumulator())
      .then(() => {
        this.setState({
          isSavingTeamNumbers: false,
          isAssignTeamNumbersModalOpen: false,
          itemsAccumulatorSelected: [],
          isSelectAllItemsAccumulatorChecked: false
        });
      })
      .catch(error => {
        this.setState({
          isSavingTeamNumbers: false,
          teamNumbersError: this.getErrorText(error)
        });
      });
  };

  onItemsFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsFilters: nextFilters
    });
  };

  onItemsAccumulatorFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsAccumulatorFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsAccumulatorFilters: nextFilters
    });
  };

  onItemsFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsFilter } = this.state;

    this.setState({
      isShowItemsFilter: !isShowItemsFilter
    });
  };

  onItemsAccumulatorFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsAccumulatorFilter } = this.state;

    this.setState({
      isShowItemsAccumulatorFilter: !isShowItemsAccumulatorFilter
    });
  };

  getItemsFilter(page, itemsAccumulator, itemsAddBuffer, isAllItems = false) {
    const { itemsFilters, forms, itemsSearch } = this.state;

    const {
      gender: itemsFiltersGender,
      firstName: itemsFiltersFirstName = '',
      lastName: itemsFiltersLastName = '',
      ages: itemsFiltersAges = [],
      forms: itemsFiltersForms = [],
      houses: itemsFiltersHouses = []
    } = itemsFilters;

    let where: any = {};

    if (itemsFiltersGender.length > 0) {
      propz.set(where, ['gender', '$in'], itemsFiltersGender);
    }

    const allItems = [...itemsAccumulator, ...itemsAddBuffer];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (itemsFiltersAges.length > 0) {
      propz.set(where, ['formAge', '$in'], itemsFiltersAges.map(Number));
    }

    if (itemsFiltersForms.length > 0) {
      this.props.isAgeGroupColumnEnabled
        ? propz.set(where, ['formAge', '$in'], itemsFiltersForms.map(Number))
        : propz.set(where, ['formId', '$in'], itemsFiltersForms);
    }

    if (itemsFiltersHouses.length > 0) {
      propz.set(where, ['houseId', '$in'], itemsFiltersHouses);
    }

    let and = [];

    if (itemsFiltersFirstName.length > 0) {
      and.push({ firstName: { like: itemsFiltersFirstName, options: 'i' } });
    }

    if (itemsFiltersLastName.length > 0) {
      and.push({ lastName: { like: itemsFiltersLastName, options: 'i' } });
    }

    if (itemsSearch.trim().length > 0) {
      const searchValue = itemsSearch.trim();
      and.push({
        $or: [{ firstName: { like: searchValue, options: 'i' } }, { lastName: { like: searchValue, options: 'i' } }]
      });
    }

    if (and.length > 0) {
      propz.set(where, ['$and'], and);
    }

    const filter = {
      where: where,
      limit: isAllItems ? DEFAULT_LIMIT : LIMIT,
      skip: isAllItems ? 0 : (page - 1) * LIMIT,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };

    return filter;
  }

  itemsSetCurrentPageParams = (currentPage: number): void => {
    const { user } = this.props;
    const { itemsAccumulator, sortItemsColumnsName, sortItemsDirection, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });

    let orderForFilter = undefined;

    if (sortItemsColumnsName !== '' && sortItemsDirection !== '') {
      orderForFilter = `${sortItemsColumnsName} ${sortItemsDirection}`;
    }

    const filter = this.getItemsFilter(currentPage, itemsAccumulator, itemsAddBuffer, orderForFilter);

    this.getEligibleStudents(user, filter)
      .then(students => {
        const studentsNormalized = this.getStudentsNormalized(students);
        this.setState({
          itemCurrentPage: currentPage,
          items: studentsNormalized,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          errorMessage: this.getErrorText(error)
        });
      });
  };

  itemsOnApplyFilterClick = (isSilent = false) => {
    const { itemsAccumulator, itemsAddBuffer } = this.state;
    const requestId = ++this.itemsSearchRequestId;

    if (isSilent) {
      this.setState({ isItemsLoading: true });
    } else {
      this.setState({ isLoading: true, isShowYounger: false });
    }

    const filter = this.getItemsFilter(1, itemsAccumulator, itemsAddBuffer);

    const { user } = this.props;

    const getStudentsPromise = this.getEligibleStudents(user, filter);
    const getStudentCountPromise = this.getEligibleStudentsCount(user, filter);

    BPromise.all([getStudentsPromise, getStudentCountPromise])
      .then(([students, studentsCount]) => {
        if (requestId !== this.itemsSearchRequestId) return;
        const studentsNormalized = this.getStudentsNormalized(students as SchoolStudentClash[]);
        this.setState({
          items: studentsNormalized,
          isLoading: false,
          isItemsLoading: false,
          itemsCount: (studentsCount as Count).count,
          itemsAccumulatorSelected: [],
          itemsSelected: [],
          itemCurrentPage: 1,
          sortItemsDirection: '',
          sortItemsColumnsName: ''
        });
      })
      .catch(error => {
        if (requestId !== this.itemsSearchRequestId) return;
        this.setState({
          isLoading: false,
          isItemsLoading: false,
          errorMessage: this.getErrorText(error)
        });
      });
  };

  onReplaceItemsFilters = (filters: any) => {
    this.setState({ itemsFilters: filters }, () => this.itemsOnApplyFilterClick());
  };

  onItemsSearchChange = (itemsSearch: string) => {
    this.setState({ itemsSearch, isItemsLoading: true }, () => this.itemsOnApplyFilterClick(true));
  };

  itemsAccumulatorOnApplyFilterClick = () => {};

  itemsOnClearFilterClick = () => {
    const { itemsAccumulatorInitial, itemsAddBuffer, team, forms, isShowYounger } = this.state;

    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms);

    this.setState({
      isLoading: true,
      itemsFilters: defaultItemsFilter,
      isShowYounger: false
    });

    const { gender: itemsFiltersGender } = defaultItemsFilter;

    let where = {
      gender: {
        $in: itemsFiltersGender
      }
    };

    const allItems = [...itemsAccumulatorInitial, ...itemsAddBuffer];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (this.props.isAgeGroupColumnEnabled) {
      if (defaultItemsFilter.forms.length > 0) {
        propz.set(where, ['formAge', '$in'], defaultItemsFilter.forms.map(Number));
      }
    } else if (defaultItemsFilter.ages.length > 0) {
      propz.set(where, ['formAge', '$in'], defaultItemsFilter.ages.map(Number));
    }

    const filter = {
      where: where,
      limit: LIMIT,
      skip: DEFAULT_SKIP,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };

    const { user } = this.props;

    const getStudentsPromise = this.getEligibleStudents(user, filter);
    const getSchoolsCountPromise = this.getEligibleStudentsCount(user, filter);

    BPromise.all([getStudentsPromise, getSchoolsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students as SchoolStudentClash[]);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: (studentsCount as Count).count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: '',
        sortItemsDirection: '',
        isItemsFiltered: true,
        isShowItemsFilter: false
      });
    });
  };

  itemsAccumulatorOnClearFilterClick = () => {};

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const searchFromState = propz.get(state, ['search'], '');
    const prevRoutePath = propz.get(state, ['prevRoutePath'], '/tournaments/teams');
    const teamsSearch = propz.get(state, ['teamsSearch'], '');
    const tournamentId = this.getTournamentId();
    const isSchoolTeamManager = location.pathname === '/tournaments/teamPlayers/manage';

    history.push({
      pathname: isSchoolTeamManager ? '/tournaments/teams' : prevRoutePath || '/tournaments/teams',
      search: isSchoolTeamManager
        ? teamsSearch || `tournamentId=${tournamentId}`
        : searchFromState || `tournamentId=${tournamentId}`,
      state
    });
  };

  renderExitConfirmationModal = () => {
    const { isExitConfirmationModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isExitConfirmationModalOpen}
        showHeader={false}
        showFooter={false}
        bodyClassName="tournamentParticipantsExitModalHost"
        dialogStyle={{ maxWidth: 520 }}
        onBackdropClick={this.closeExitConfirmationModal}
      >
        <section className="tournamentParticipantsExitModal" role="dialog" aria-label="Discard participant changes">
          <header>
            <div>
              <h2>Leave without saving?</h2>
              <p>Your staged participant changes have not been saved.</p>
            </div>
            <button type="button" onClick={this.closeExitConfirmationModal} aria-label="Close">
              ×
            </button>
          </header>
          <div className="tournamentParticipantsExitModal__body">
            If you leave this page now, the changes you made to this tournament team will be lost.
          </div>
          <footer>
            <button type="button" onClick={this.closeExitConfirmationModal}>
              Keep editing
            </button>
            <button type="button" className="isDanger" onClick={this.goBack}>
              Leave without saving
            </button>
          </footer>
        </section>
      </SimpleModal>
    );
  };

  openExitConfirmationModal = () => {
    this.setState({
      isExitConfirmationModalOpen: true
    });
  };

  closeExitConfirmationModal = () => {
    this.setState({
      isExitConfirmationModalOpen: false
    });
  };

  onBackButtonClick = () => {
    const { itemsAddBuffer, itemsRemoveBuffer } = this.state;
    const isThereAnyChanges = itemsAddBuffer.length > 0 || itemsRemoveBuffer.length > 0;

    isThereAnyChanges ? this.openExitConfirmationModal() : this.goBack();
  };

  onSelectAllItemsClick = () => {
    const { itemsSelected, itemCurrentPage, itemsAccumulatorInitial, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;
    const nextItemsAddBuffer = [...itemsAddBuffer, ...itemsSelected];
    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulatorInitial, nextItemsAddBuffer, true);

    this.getAllEligibleStudents(user, filter).then(items => {
      const itemsFiltered = items.filter(item => {
        return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
      });

      const studentsNormalizedFiltered = this.getStudentsNormalized(itemsFiltered);

      const nextSelectedItems = [...itemsSelected, ...studentsNormalizedFiltered];

      this.setState({
        itemsSelected: nextSelectedItems,
        isSelectAllItemsChecked: true,
        itemsAccumulatorSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsOnPageClick = () => {
    const { items, itemsSelected } = this.state;

    const itemsFiltered = items.filter(item => {
      return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsSelected, ...itemsFiltered];

    this.setState({
      itemsSelected: nextSelectedItems,
      isSelectAllItemsChecked: true,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onUnselectAllItemsClick = () => {
    this.setState({
      itemsSelected: [],
      isSelectAllItemsChecked: false,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onSelectAllItemsAccumulatorClick = () => {
    const { itemsAccumulatorSelected, itemsAccumulatorFilters } = this.state;

    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();
    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);

    this.getApi()
      .getAllTeamPlayers(user, tournamentId, teamId, where)
      .then(teamPlayers => {
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);

        const teamPlayersFiltered = teamPlayersNormalized.filter(teamPlayer => {
          return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== teamPlayer.id);
        });

        const nextSelectedItems = [...itemsAccumulatorSelected, ...teamPlayersFiltered];

        this.setState({
          itemsAccumulatorSelected: nextSelectedItems,
          isSelectAllItemsAccumulatorChecked: true,
          itemsSelected: [],
          isSelectAllItemsChecked: false,
          isLoading: false
        });
      });
  };

  onSelectAllItemsAccumulatorOnPageClick = () => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;

    const itemsFiltered = itemsAccumulator.filter(item => {
      return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsAccumulatorSelected, ...itemsFiltered];

    this.setState({
      itemsAccumulatorSelected: nextSelectedItems,
      isSelectAllItemsAccumulatorChecked: true,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onUnselectAllItemsAccumulatorClick = () => {
    this.setState({
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onSortItemsClick = (sortField: string) => {
    const { sortItemsDirection, sortItemsColumnsName, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    const order = getOrder(sortField, sortItemsDirection, sortItemsColumnsName) as TABLE_SORT_DIRECTION;
    const orderForFilter = `${sortField} ${order}`;

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer);
    const { user } = this.props;
    const getSchoolStudentsPromise = this.getEligibleStudents(user, filter);
    const getSchoolStudentsCountPromise = this.getEligibleStudentsCount(user, filter);

    Promise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students as SchoolStudentClash[]);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: ((studentsCount as unknown) as Count).count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: sortField,
        sortItemsDirection: order
      });
    });
  };

  onSortItemsAccumulatorClick = (sortField: string) => {};

  onClashClick = (student: SchoolStudentClash | SchoolEventTeamPlayerWithClashes) => {
    const { user } = this.props;
    const { clashes, firstName, lastName } = student;
    const { fullClashEvents, intervalClashEvents } = clashes;
    const fullClashEventIds = fullClashEvents.map(fullClashEvent => fullClashEvent._id);
    const intervalClashEventIds = intervalClashEvents.map(intervalClashEvent => intervalClashEvent._id);

    const allPlayerEventIds = [...fullClashEventIds, ...intervalClashEventIds];
    const allPlayerEventIdsUniq = Lazy(allPlayerEventIds)
      .uniq()
      .toArray();

    this.setState({
      isLoading: true
    });

    const eventsPromise: Promise<SchoolEvent>[] = allPlayerEventIdsUniq.map(eventId => getSchoolEvent(user, eventId));

    BPromise.all(eventsPromise).then(events => {
      const eventNames = events
        .map((event, index) => {
          const title = getEventTitle(event, user);
          const clash = getEventClash(event, fullClashEventIds, intervalClashEventIds);
          return `${index + 1}. ${title} ${clash}`;
        })
        .join('\n ');

      this.setState({
        isLoading: false,
        studentEventsModalText: `${firstName} ${lastName} is participating in the following events: \n${eventNames}`,
        isStudentEventsModalOpen: true
      });
    });
  };

  onCloseStudentEventsModalClick = () => {
    this.setState({
      isStudentEventsModalOpen: false
    });
  };

  renderStudentEventsModal(): React.ReactNode {
    const { isStudentEventsModalOpen, studentEventsModalText } = this.state;
    return (
      <SimpleModal
        isOpen={isStudentEventsModalOpen}
        title={'Info'}
        body={studentEventsModalText}
        buttonText={'Ok'}
        onButtonClick={this.onCloseStudentEventsModalClick}
      />
    );
  }

  onShowYoungerChange = () => {
    const { user } = this.props;
    const { team, forms, isShowYounger, itemsAccumulatorInitial, itemsAddBuffer } = this.state;

    const nextShowYounger = !isShowYounger;
    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms, !nextShowYounger);

    this.setState({
      isLoading: true,
      itemsFilters: defaultItemsFilter,
      isShowYounger: nextShowYounger
    });

    const {
      gender: itemsFiltersGender,
      ages: itemsFiltersAges = [],
      forms: itemsFiltersForms = []
    } = defaultItemsFilter;

    let where = {
      gender: {
        $in: itemsFiltersGender
      }
    };

    const allItems = [...itemsAccumulatorInitial, ...itemsAddBuffer];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (itemsFiltersAges.length > 0) {
      propz.set(where, ['formAge', '$in'], itemsFiltersAges.map(Number));
    }

    if (itemsFiltersForms.length > 0) {
      this.props.isAgeGroupColumnEnabled
        ? propz.set(where, ['formAge', '$in'], itemsFiltersForms.map(Number))
        : propz.set(where, ['formId', '$in'], itemsFiltersForms);
    }

    const filter = {
      where: where,
      limit: LIMIT,
      skip: DEFAULT_SKIP,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };

    const getStudentsPromise = this.getEligibleStudents(user, filter);
    const getSchoolsCountPromise = this.getEligibleStudentsCount(user, filter);

    BPromise.all([getStudentsPromise, getSchoolsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: '',
        sortItemsDirection: '',
        isItemsFiltered: true,
        isShowItemsFilter: false
      });
    });
  };

  openAddStudentModal = () => {
    if (this.isUnionTeamStudentFormMode()) {
      const schoolId = this.getContextSchoolId();

      if (!schoolId) {
        this.setState({ errorMessage: 'The school for this team could not be identified.' });
        return;
      }

      this.setState({
        isAddStudentModalOpen: true,
        chosenSchoolId: schoolId,
        chosenSchoolForms: this.state.forms,
        errorMessage: '',
        studentToAdd: null
      });
      return;
    }

    this.setState(
      {
        isAddStudentModalOpen: true,
        studentToAdd: null
      },
      () => console.log('Modal Open State:', this.state.isAddStudentModalOpen)
    );
  };

  closeAddStudentModal = () => {
    this.setState({
      isAddStudentModalOpen: false,
      studentToAdd: null,
      chosenSchoolId: '',
      chosenSchoolForms: []
    });
  };

  onSubmitAddStudent = async (data, isContinue) => {
    const { user } = this.props;
    const studentFormUser = this.props.studentFormUser || user;
    const { itemsAccumulatorInitial, itemsAddBuffer, chosenSchoolId } = this.state;
    const api = this.getApi();

    const transformedData: any = {
      ...data,
      formId: data.form?.id || null
    };

    if (data.house?.id && /^[a-fA-F0-9]{24}$/.test(data.house.id)) {
      transformedData.houseId = data.house.id;
    } else {
      delete transformedData.houseId;
    }

    try {
      const newStudent = this.isUnionTeamStudentFormMode()
        ? api.addStudent
          ? await api.addStudent(user, transformedData)
          : await addSchoolUnionSchoolStudent(
              this.props.unionTeamStudentFormUser || user,
              chosenSchoolId,
              transformedData
            )
        : api.addStudent
        ? await api.addStudent(user, transformedData)
        : await addSchoolStudent(studentFormUser, transformedData);
      const filter = this.getItemsFilter(1, itemsAccumulatorInitial, itemsAddBuffer);
      const [updatedStudents, updatedCount] = await Promise.all([
        this.getEligibleStudents(user, filter),
        this.getEligibleStudentsCount(user, filter)
      ]);

      const normalizedStudents = this.getStudentsNormalized(updatedStudents);

      this.setState(prevState => ({
        isAddStudentModalOpen: isContinue,
        items: normalizedStudents,
        itemsCount: updatedCount.count,
        studentToAdd: isContinue ? null : null,
        errorMessage: ''
      }));

      return true;
    } catch (error) {
      console.error('Error adding student:', error);
      this.setState({
        errorMessage: 'Failed to add student. Please try again.'
      });
      return false;
    }
  };

  openEditStudentModal = () => {
    const { itemsSelected } = this.state;
    if (itemsSelected.length === 1) {
      this.setState({
        isEditStudentModalOpen: true,
        studentToEdit: itemsSelected[0]
      });
    }
  };

  closeEditStudentModal = () => {
    this.setState({
      isEditStudentModalOpen: false,
      studentToEdit: null
    });
  };

  onSubmitEditStudent = async (
    data: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean
  ): Promise<boolean> => {
    const { user } = this.props;
    const { studentToEdit } = this.state;

    if (!studentToEdit) return false;

    const transformedData: any = {
      ...data,
      formId: data.form?.id || null
    };

    if (data.house?.id && /^[a-fA-F0-9]{24}$/.test(data.house.id)) {
      transformedData.houseId = data.house.id;
    } else {
      delete transformedData.houseId;
    }

    try {
      const updateStudent = this.props.api?.updateStudent || updateSchoolStudent;
      await updateStudent(user, studentToEdit.id, transformedData);

      this.setState(prevState => {
        const updatedItems = prevState.items.map(item =>
          item.id === studentToEdit.id ? { ...item, ...transformedData } : item
        );

        const updatedItemsAccumulator = prevState.itemsAccumulator.map(item =>
          item.id === studentToEdit.id ? { ...item, ...transformedData } : item
        );

        return {
          items: updatedItems,
          itemsAccumulator: updatedItemsAccumulator
        };
      });

      this.closeEditStudentModal();
      return true;
    } catch (error) {
      console.error('Error updating student:', error);
      this.setState({
        errorMessage: 'Failed to update student. Please try again.'
      });
      return false;
    }
  };

  renderAddStudentModal() {
    const { isAddStudentModalOpen, studentToAdd, forms, houses, chosenSchoolId, chosenSchoolForms } = this.state;
    const { user } = this.props;
    const studentFormUser = this.props.studentFormUser || user;

    if (!isAddStudentModalOpen) return null;

    if (this.isUnionTeamStudentFormMode()) {
      const formUser = this.props.unionTeamStudentFormUser || user;

      return (
        <SimpleModal
          isOpen={isAddStudentModalOpen}
          onCloseClick={() => this.studentFormRef.current?.requestClose()}
          title="Add Student"
          showFooter={false}
          customClass="unionStudentModal"
          dialogStyle={{ maxWidth: 560 }}
        >
          <SchoolUnionSchoolStudentForm
            ref={this.studentFormRef}
            student={studentToAdd || { firstName: '', lastName: '', formId: '' }}
            onSubmit={this.onSubmitAddStudent}
            onCancel={this.closeAddStudentModal}
            user={formUser}
            isCreateStudentsChain={false}
            identicalStudents={[]}
            similarStudents={[]}
            isFormsExist={chosenSchoolForms && chosenSchoolForms.length > 0}
            isEditStudent={false}
            schoolId={chosenSchoolId}
          />
        </SimpleModal>
      );
    }

    return (
      <SimpleModal
        isOpen={isAddStudentModalOpen}
        onCloseClick={this.closeAddStudentModal}
        title="Add Student"
        showFooter={false}
      >
        <StudentForm
          student={studentToAdd || { firstName: '', lastName: '', formId: '', houseId: '' }}
          onSubmit={this.onSubmitAddStudent}
          onCancel={this.closeAddStudentModal}
          user={studentFormUser}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={forms && forms.length > 0}
          isEditStudent={false}
          searchFunctionForms={text => this.searchLoadedItems(forms, text)}
          searchFunctionHouses={text => this.searchLoadedItems(houses, text)}
        />
      </SimpleModal>
    );
  }

  renderEditPlayerNumberModal() {
    const { isEditPlayerNumberModalOpen, itemsAccumulatorSelected } = this.state;

    if (!isEditPlayerNumberModalOpen || itemsAccumulatorSelected.length !== 1) {
      return null;
    }

    const selectedPlayer = itemsAccumulatorSelected[0];
    const playerName = `${selectedPlayer.firstName} ${selectedPlayer.lastName}`;

    return (
      <SimpleModal
        isOpen={isEditPlayerNumberModalOpen}
        onCloseClick={this.closeEditPlayerNumberModal}
        title="Edit athlete number"
        showFooter={false}
        isBodyBold={false}
        customClass="tournamentPlayerNumberModal"
        dialogStyle={{ maxWidth: 420 }}
      >
        <form className="tournamentPlayerNumberForm" onSubmit={this.onSubmitEditPlayerNumber}>
          <div className="tournamentPlayerNumberForm__person">
            <span>{`${selectedPlayer.firstName || ''} ${selectedPlayer.lastName || ''}`.trim().charAt(0)}</span>
            <div>
              <strong>{playerName}</strong>
              <small>{this.state.team?.name || 'Tournament team'}</small>
            </div>
          </div>
          <label>
            <span>Athlete number</span>
            <input
              type="number"
              min="1"
              autoFocus
              value={this.state.editPlayerNumberValue}
              placeholder="No number"
              onChange={event => this.setState({ editPlayerNumberValue: event.target.value, playerNumberError: '' })}
            />
            <small>The number must be unique across the tournament. Leave empty to remove it.</small>
          </label>
          {this.state.playerNumberError ? (
            <div className="tournamentPlayerNumberForm__error">{this.state.playerNumberError}</div>
          ) : null}
          <footer>
            <button type="button" disabled={this.state.isSavingPlayerNumber} onClick={this.closeEditPlayerNumberModal}>
              Cancel
            </button>
            <button className="is-primary" type="submit" disabled={this.state.isSavingPlayerNumber}>
              {this.state.isSavingPlayerNumber ? 'Saving…' : 'Save number'}
            </button>
          </footer>
        </form>
      </SimpleModal>
    );
  }

  renderAssignTeamNumbersModal() {
    const { isAssignTeamNumbersModalOpen } = this.state;

    if (!isAssignTeamNumbersModalOpen) {
      return null;
    }

    return (
      <SimpleModal
        isOpen={isAssignTeamNumbersModalOpen}
        onCloseClick={this.closeAssignTeamNumbersModal}
        title="Assign team numbers"
        showFooter={false}
        isBodyBold={false}
        customClass="tournamentTeamNumbersModal"
        dialogStyle={{ maxWidth: 440 }}
      >
        <form className="tournamentTeamNumbersForm" onSubmit={this.onSubmitAssignTeamNumbers}>
          <p>
            Assign unique tournament numbers to members of <strong>{this.state.team?.name}</strong>.
          </p>
          <div className="tournamentTeamNumbersForm__range">
            <label>
              <span>
                Start from <b>*</b>
              </span>
              <input
                type="number"
                min="1"
                required
                autoFocus
                value={this.state.assignTeamNumbersStart}
                onChange={event => this.setState({ assignTeamNumbersStart: event.target.value, teamNumbersError: '' })}
              />
            </label>
            <label>
              <span>End at</span>
              <input
                type="number"
                min="1"
                placeholder="Optional"
                value={this.state.assignTeamNumbersEnd}
                onChange={event => this.setState({ assignTeamNumbersEnd: event.target.value, teamNumbersError: '' })}
              />
            </label>
          </div>
          <fieldset>
            <legend>Assignment mode</legend>
            <label className="tournamentTeamNumbersForm__option">
              <input
                type="radio"
                name="assignTeamMode"
                checked={this.state.assignTeamNumbersMode === 'FILL_MISSING'}
                onChange={() => this.setState({ assignTeamNumbersMode: 'FILL_MISSING' })}
              />
              <span>
                <strong>Fill missing numbers only</strong>
                <small>Keep existing athlete numbers unchanged.</small>
              </span>
            </label>
            <label className="tournamentTeamNumbersForm__option">
              <input
                type="radio"
                name="assignTeamMode"
                checked={this.state.assignTeamNumbersMode === 'RENUMBER_ALL'}
                onChange={() => this.setState({ assignTeamNumbersMode: 'RENUMBER_ALL' })}
              />
              <span>
                <strong>Renumber all athletes</strong>
                <small>Replace all existing numbers in this team.</small>
              </span>
            </label>
          </fieldset>
          {this.state.teamNumbersError ? (
            <div className="tournamentTeamNumbersForm__error">{this.state.teamNumbersError}</div>
          ) : null}
          <footer>
            <button type="button" disabled={this.state.isSavingTeamNumbers} onClick={this.closeAssignTeamNumbersModal}>
              Cancel
            </button>
            <button
              className="is-primary"
              type="submit"
              disabled={this.state.isSavingTeamNumbers || !this.state.assignTeamNumbersStart}
            >
              {this.state.isSavingTeamNumbers ? 'Assigning…' : 'Assign numbers'}
            </button>
          </footer>
        </form>
      </SimpleModal>
    );
  }

  renderEditStudentModal() {
    const { isEditStudentModalOpen, studentToEdit, forms, chosenSchoolId, chosenSchoolForms } = this.state;
    const { user } = this.props;

    if (!isEditStudentModalOpen || !studentToEdit) return null;

    if (this.isUnionTeamStudentFormMode()) {
      const formUser = this.props.unionTeamStudentFormUser || user;
      const schoolId = studentToEdit.schoolId || chosenSchoolId || this.getContextSchoolId();

      return (
        <SimpleModal
          isOpen={isEditStudentModalOpen}
          onCloseClick={() => this.studentFormRef.current?.requestClose()}
          title="Edit Student"
          showFooter={false}
          customClass="unionStudentModal"
          dialogStyle={{ maxWidth: 560 }}
        >
          <SchoolUnionSchoolStudentForm
            ref={this.studentFormRef}
            student={studentToEdit}
            onSubmit={this.onSubmitEditStudent}
            onCancel={this.closeEditStudentModal}
            user={formUser}
            isCreateStudentsChain={false}
            identicalStudents={[]}
            similarStudents={[]}
            isFormsExist={(chosenSchoolForms.length > 0 ? chosenSchoolForms : forms || []).length > 0}
            isEditStudent={true}
            schoolId={schoolId}
          />
        </SimpleModal>
      );
    }

    return (
      <SimpleModal
        isOpen={isEditStudentModalOpen}
        onCloseClick={this.closeEditStudentModal}
        title="Edit Student"
        showFooter={false}
      >
        <StudentForm
          student={studentToEdit}
          onSubmit={this.onSubmitEditStudent}
          onCancel={this.closeEditStudentModal}
          user={user}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={forms && forms.length > 0}
          isEditStudent={true}
        />
      </SimpleModal>
    );
  }

  getColumnsWithClashes = (): ColumnDefinition[] => [
    studentBirthdayColumn,
    {
      text: 'Clashes',
      field: 'clashes',
      cell: getColorClashes,
      type: FILTER_TYPE.NONE,
      isSort: false
    },
    {
      text: 'Surname',
      field: 'lastName',
      accessor: ['lastName'],
      type: FILTER_TYPE.TEXT,
      isSort: false
    },
    {
      text: 'Name',
      field: 'firstName',
      accessor: ['firstName'],
      type: FILTER_TYPE.TEXT,
      isSort: false
    },
    {
      text: 'Form',
      field: 'forms',
      isSort: false,
      type: FILTER_TYPE.MULTISELECT,
      accessor: ['form', 'name']
    },
    {
      text: 'Gender',
      field: 'gender',
      isSort: false,
      type: FILTER_TYPE.MULTISELECT,
      accessor: getGender
    },
    this.getActionsColumn(this.handleEditClick)
  ];

  renderTeamPlayerConflictsModal() {
    const { teamPlayerConflicts } = this.state;

    return (
      <SimpleModal
        isOpen={teamPlayerConflicts.length > 0}
        title="Student already selected"
        onCloseClick={this.closeTeamPlayerConflicts}
        onBackdropClick={this.closeTeamPlayerConflicts}
        showFooter={false}
        isBodyBold={false}
        customClass="tournamentTeamConflictModal"
        dialogStyle={{ maxWidth: 680 }}
      >
        <div className="tournamentTeamConflictModal__body">
          <p className="tournamentTeamConflictModal__intro">
            Some students are already assigned to another team in this tournament. Choose which team each student will
            represent.
          </p>
          <div className="tournamentTeamConflictModal__list">
            {teamPlayerConflicts.map(conflict => (
              <div className="tournamentTeamConflictModal__row" key={conflict.userId}>
                <strong>{conflict.playerName}</strong>
                <div className="tournamentTeamConflictModal__choices">
                  {conflict.teams.map(team => (
                    <label key={team.teamId}>
                      <input
                        type="radio"
                        name={`tournament-player-team-${conflict.userId}`}
                        checked={conflict.selectedTeamId === team.teamId}
                        onChange={() => this.setTeamPlayerConflictChoice(conflict.userId, team.teamId)}
                      />
                      <span>
                        Keep in <b>{team.teamName}</b>
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="tournamentTeamConflictModal__actions">
            <button type="button" onClick={this.closeTeamPlayerConflicts}>
              Cancel
            </button>
            <button type="button" onClick={this.confirmTeamPlayerConflicts}>
              Apply choices
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  render() {
    const {
      items,
      isLoading,
      itemsSelected,
      itemsAccumulatorSelected,
      itemsAccumulator,
      itemsFilters,
      isShowItemsFilter,
      isItemsFiltered,
      itemsCount,
      itemsAccumulatorCount,
      itemCurrentPage,
      itemsAccumulatorFilters,
      isShowItemsAccumulatorFilter,
      isItemsAccumulatorFiltered,
      tournament,
      isSelectAllItemsChecked,
      isSelectAllItemsAccumulatorChecked,
      sortItemsDirection,
      sortItemsColumnsName,
      sortItemsAccumulatorDirection,
      sortItemsAccumulatorColumnsName,
      itemsAddBuffer,
      itemsRemoveBuffer,
      isStudentEventsModalOpen,
      forms,
      houses,
      isShowYounger,
      errorMessage,
      isAddStudentModalOpen,
      studentToAdd,
      isEditStudentModalOpen,
      studentToEdit,
      isCheckingTeamPlayerConflicts,
      itemsHiddenFields,
      itemsAccumulatorHiddenFields,
      isItemsLoading
    } = this.state;

    const schoolNameFromState = propz.get(this.props.location, ['state', 'contextSchoolName'], '');
    const schoolName =
      propz.get(this.state, ['team', 'school', 'name']) ||
      propz.get(this.state, ['team', 'schoolName']) ||
      schoolNameFromState;
    const schoolLogo =
      propz.get(this.state, ['team', 'school', 'pic']) ||
      propz.get(this.state, ['team', 'school', 'picUrl']) ||
      propz.get(this.state, ['team', 'schoolPic']);

    if (isLoading || isCheckingTeamPlayerConflicts || !tournament || !this.state.team) {
      return <Loader />;
    }

    const { user } = this.props;
    const { activeSchool } = user;
    const { ageGroupsNaming, isShowStudentEventClashes } = activeSchool;
    const tournamentAges = (this.state.team.ages || []).map(Number).filter(Number.isFinite);
    const maximumTournamentAge = tournamentAges.length ? Math.max(...tournamentAges) : -1;
    const eligibleForms = forms.filter(form => Number(form.age) <= maximumTournamentAge);

    const allItemsColumns = isShowStudentEventClashes ? this.getColumnsWithClashes() : this.getItemsColumns();
    const allAccumulatorColumns = this.getItemsAccumulatorColumns();
    const visibleItemsColumns = allItemsColumns.filter(column => !itemsHiddenFields.has(column.field));
    const visibleAccumulatorColumns = allAccumulatorColumns.filter(
      column => !itemsAccumulatorHiddenFields.has(column.field)
    );

    const itemsFiltersOptions = {
      ages: getSelectOptionForAge(eligibleForms, ageGroupsNaming),
      gender: getSelectOptionForGender(),
      houses: getSelectOptionForHouses(houses),
      forms: this.props.isAgeGroupColumnEnabled
        ? getSelectOptionForAge(eligibleForms, ageGroupsNaming)
        : getSelectOptionForForms(eligibleForms)
    };

    const itemsAccumulatorFiltersOptions = {};
    const team = this.state.team;
    const teamGenderPreset = getUserGenderArrayConvertedFromEventGender(team.gender);
    const teamDefaultFilters = this.getDefaultItemsFilter(team, forms, true);
    const itemsPresetFilters = {
      ages: (teamDefaultFilters.ages || []).map(String),
      forms: (teamDefaultFilters.forms || []).map(String),
      gender: teamGenderPreset.length === 1 ? teamGenderPreset.map(String) : []
    };
    const stagedParticipantsCount = itemsAccumulator.length;
    const teamCapacity = Number(tournament.maxPlayersPerTeam) || 0;
    const isTeamCapacityExceeded = teamCapacity > 0 && stagedParticipantsCount > teamCapacity;
    const hasUnsavedChanges = itemsAddBuffer.length > 0 || itemsRemoveBuffer.length > 0;
    const canEditAthleteNumber =
      !hasUnsavedChanges && itemsAccumulatorSelected.length === 1 && Boolean(itemsAccumulatorSelected[0].playerId);
    const classes = isStudentEventsModalOpen ? 'modal-open' : '';

    return (
      <div className={`ttm-page tournamentTeamPlayersModern ${classes}`}>
        {this.renderStudentEventsModal()}
        {this.renderExitConfirmationModal()}
        {this.renderAddStudentModal()}
        {this.renderEditStudentModal()}
        {this.renderEditPlayerNumberModal()}
        {this.renderAssignTeamNumbersModal()}
        {this.renderTeamPlayerConflictsModal()}
        <header className="tournamentTeamPlayersModern__header">
          <button type="button" className="tournamentTeamPlayersModern__back" onClick={this.onBackButtonClick}>
            <span aria-hidden="true">←</span> Back to teams
          </button>
          <div className="tournamentTeamPlayersModern__headingRow">
            <div className="tournamentTeamPlayersModern__identity">
              <div className="tournamentTeamPlayersModern__contextTitle">
                Managing team members for <strong>{tournament.name}</strong>
              </div>
              <div className="tournamentTeamPlayersModern__teamDetails">
                {schoolLogo ? (
                  <img src={schoolLogo} alt="" />
                ) : (
                  <span className="tournamentTeamPlayersModern__schoolInitial" aria-hidden="true">
                    {(schoolName || team.name || 'T')
                      .trim()
                      .charAt(0)
                      .toUpperCase()}
                  </span>
                )}
                <div>
                  <strong>{team.name}</strong>
                  <span>{schoolName || 'Tournament team'}</span>
                </div>
              </div>
            </div>
            <div className="tournamentTeamPlayersModern__summary">
              <span className={isTeamCapacityExceeded ? 'is-over-limit' : undefined}>
                <strong>{stagedParticipantsCount}</strong> participants
                {isTeamCapacityExceeded && ` · ${stagedParticipantsCount - teamCapacity} over limit`}
              </span>
              {teamCapacity > 0 && (
                <>
                  <span className={isTeamCapacityExceeded ? 'is-over-limit' : undefined}>
                    <strong>{teamCapacity}</strong> maximum
                  </span>
                  <span className={isTeamCapacityExceeded ? 'is-over-limit' : 'is-available'}>
                    <strong>{Math.max(0, teamCapacity - stagedParticipantsCount)}</strong> places available
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="tournamentTeamPlayersModern__toolbar">
            <Switch
              name="isShowYounger"
              checked={isShowYounger}
              onChange={this.onShowYoungerChange}
              text="Show younger students"
            />
            <div className="tournamentTeamPlayersModern__toolbarActions">
              <button type="button" onClick={this.openAddStudentModal}>
                <span aria-hidden="true">＋</span> Add student
              </button>
              {this.props.isPlayerNumbersEnabled && (
                <>
                  <button
                    type="button"
                    disabled={!canEditAthleteNumber}
                    title={
                      hasUnsavedChanges ? 'Save team changes first' : 'Select one saved team member in the right panel'
                    }
                    onClick={this.openEditPlayerNumberModal}
                  >
                    Edit athlete number
                  </button>
                  <button type="button" onClick={this.openAssignTeamNumbersModal}>
                    Assign team numbers
                  </button>
                </>
              )}
            </div>
          </div>
        </header>

        <section className="tournamentTeamPlayersModern__card">
          <div className="tournamentTeamPlayersModern__cardHead">
            <div>
              <h2>Build the team</h2>
              <p>
                Double-click a student to move them instantly, or select several and use the centre buttons. Changes are
                applied only when you save.
              </p>
            </div>
          </div>
          <div className="tournamentTeamPlayersModern__editor">
            <TwoPanelEditor
              isSourceFirst
              itemsPresetFilters={itemsPresetFilters}
              itemsPresetSourceLabel="team"
              onReplaceItemsFilters={this.onReplaceItemsFilters}
              onItemsSearchChange={this.onItemsSearchChange}
              itemsSearchValue={this.state.itemsSearch}
              isItemsLoading={isItemsLoading}
              onSelectAllFilteredItemsClick={this.onSelectAllItemsClick}
              itemsModernPagination
              //items
              items={items}
              itemsTitle={'Eligible students'}
              itemsColumns={visibleItemsColumns}
              itemsSelected={itemsSelected}
              onItemClick={this.onItemClick}
              //items filters
              onItemsFilterChange={this.onItemsFilterChange}
              itemsFilters={itemsFilters}
              itemsFiltersOptions={itemsFiltersOptions}
              itemsFilterLabels={{
                ages: 'Age groups',
                forms: this.props.isAgeGroupColumnEnabled ? 'Age groups' : 'Reg forms'
              }}
              isShowItemsFilter={isShowItemsFilter}
              isItemsFiltered={isItemsFiltered}
              onItemsFilterClick={this.onItemsFilterClick}
              //accumulator
              itemsAccumulator={itemsAccumulator}
              itemsAccumulatorTitle={'Team members'}
              itemsAccumulatorSearchByNameOnly={Boolean(this.props.isUnionSide)}
              itemsAccumulatorColumns={visibleAccumulatorColumns}
              onItemAccumulatorClick={this.onItemAccumulatorClick}
              itemsAccumulatorSelected={itemsAccumulatorSelected}
              //accumulator filters
              onItemsAccumulatorFilterChange={this.onItemsAccumulatorFilterChange}
              itemsAccumulatorFilters={itemsAccumulatorFilters}
              itemsAccumulatorFiltersOptions={itemsAccumulatorFiltersOptions}
              isShowItemsAccumulatorFilter={isShowItemsAccumulatorFilter}
              isItemsAccumulatorFiltered={isItemsAccumulatorFiltered}
              onItemsAccumulatorFilterClick={this.onItemsAccumulatorFilterClick}
              //buttons
              onAddClick={this.onAddClick}
              onRemoveClick={this.onRemoveClick}
              //counts
              itemsCount={itemsCount}
              itemsAccumulatorCount={itemsAccumulatorCount}
              itemsAccumulatorCapacity={teamCapacity > 0 ? teamCapacity : undefined}
              //current pages
              itemAccumulatorCurrentPage={1}
              itemCurrentPage={itemCurrentPage}
              itemsSetCurrentPageParams={this.itemsSetCurrentPageParams}
              //items filter buttons
              itemsOnApplyFilterClick={this.itemsOnApplyFilterClick}
              itemsOnClearFilterClick={this.itemsOnClearFilterClick}
              //items accumulator filter buttons
              itemsAccumulatorOnApplyFilterClick={this.itemsAccumulatorOnApplyFilterClick}
              itemsAccumulatorOnClearFilterClick={this.itemsAccumulatorOnClearFilterClick}
              //items select checkbox
              onSelectAllItemsClick={this.onSelectAllItemsClick}
              onSelectAllItemsOnPageClick={this.onSelectAllItemsOnPageClick}
              onUnselectAllItemsClick={this.onUnselectAllItemsClick}
              isSelectAllItemsChecked={isSelectAllItemsChecked}
              //items accumulator select checkbox
              onSelectAllItemsAccumulatorClick={this.onSelectAllItemsAccumulatorClick}
              onSelectAllItemsAccumulatorOnPageClick={this.onSelectAllItemsAccumulatorOnPageClick}
              onUnselectAllItemsAccumulatorClick={this.onUnselectAllItemsAccumulatorClick}
              isSelectAllItemsAccumulatorChecked={isSelectAllItemsAccumulatorChecked}
              //items sort
              sortItemsDirection={sortItemsDirection}
              sortItemsColumnsName={sortItemsColumnsName}
              onSortItemsClick={this.onSortItemsClick}
              //items accumulator sort
              sortItemsAccumulatorDirection={sortItemsAccumulatorDirection}
              sortItemsAccumulatorColumnsName={sortItemsAccumulatorColumnsName}
              onSortItemsAccumulatorClick={this.onSortItemsAccumulatorClick}
              itemsAddBuffer={itemsAddBuffer}
              itemsRemoveBuffer={itemsRemoveBuffer}
              onCellItemsClick={this.onClashClick}
              onCellItemsAccumulatorClick={this.onClashClick}
              removeItemFromBuffer={this.removeItemFromBuffer}
              onEditClick={this.handleEditClick}
              itemsAllColumns={allItemsColumns}
              itemsHiddenFields={itemsHiddenFields}
              onToggleItemsColumn={this.onToggleItemsColumn}
              isItemsColumnToggleable={this.isColumnToggleable}
              itemsAccumulatorAllColumns={allAccumulatorColumns}
              itemsAccumulatorHiddenFields={itemsAccumulatorHiddenFields}
              onToggleItemsAccumulatorColumn={this.onToggleItemsAccumulatorColumn}
              isItemsAccumulatorColumnToggleable={this.isColumnToggleable}
            />
          </div>
        </section>

        {errorMessage && (
          <div className="tournamentTeamPlayersModern__error" role="alert">
            {errorMessage}
          </div>
        )}

        <footer className="tournamentTeamPlayersModern__footer">
          <div>
            <strong>{stagedParticipantsCount} selected</strong>
            {hasUnsavedChanges && <span>Unsaved changes</span>}
          </div>
          <div>
            <button type="button" className="isSecondary" onClick={this.onBackButtonClick}>
              Cancel
            </button>
            <button type="button" className="isPrimary" onClick={this.onClickSave} disabled={!hasUnsavedChanges}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              Save participants
            </button>
          </div>
        </footer>
      </div>
    );
  }
}
